<input
  (change)="onChange($event)"
  data-testid="file-uploader-file"
  id="fileInput"
  hidden
  type="file"
  name="file"
  [accept]="accept"
  />
  <div class="file-uploader">
    <div class="details">
      <div class="filename text-start">
        <div>
          @if (fileName) {
            <mat-icon color="primary">check_circle</mat-icon>
          }
        </div>
        <div style="display: flex; flex-direction: column">
          <div class="mx-1">
            {{ fileName ? fileName : "Upload your prescription" }}
          </div>
          <div class="mx-1">Order Number: {{ orderId }}</div>
        </div>
      </div>

      <div class="filesize text-end">
        {{ fileSize ? fileSize : "" }}
      </div>
    </div>

    <div class="action">
      <button
        mat-stroked-button
        data-testid="file-uploader-open-file-button"
        (click)="openInput()"
        >
        <mat-icon>folder_open</mat-icon> Browse
      </button>
    </div>
  </div>
  <div class="text-end my-1">
    <button
      color="primary"
      data-testid="file-uploader-upload-button"
      [disabled]="!fileSelected"
      mat-raised-button
      (click)="uploadFile()"
      >
      <mat-icon>cloud_upload</mat-icon> Upload
    </button>
  </div>